import {
    Box,
    Typography
} from "@mui/material";

import { ContactList } from "../../components/contact/ContactList";
import { usePageDefaultStyle } from "../../assets/style/usePageDefaultStyle";

export const ContactPage = () => {
    const { pageDefaultStyle } = usePageDefaultStyle();

    return (
        <Box sx={pageDefaultStyle}>
            <Box display="flex" flexDirection="column" gap={2}>
                <Typography variant="h4">Contact Book</Typography>
                <ContactList />
            </Box>
        </Box>
    );
};